import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M9 12L11 12M13 12H15M18 9.5L20 12L18 14.5M6 14.5L4 12L6 9.5" />
	</SVG>
);
